import { Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, FormGroup, Grid, IconButton } from '@mui/material'
import React, { useEffect, useState } from 'react'
import DashboardContainer from '../../components/DashboardContainer';
import PageContainer from '../../components/PageContainer'
import { AddorUpdateRecord, getList } from '../../redux/api/system'
import { Formik, Form } from 'formik'
import { useSnackbar } from 'notistack'
import { DataGrid } from '@mui/x-data-grid'
import TextInput from '../../components/common/TextInput'
import SelectInput from '../../components/common/SelectInput';
import CustomDataGrid from '../../components/CustomDataGrid';
import { Add, Delete, Diversity2Outlined, Edit, Label, Checkroom } from '@mui/icons-material'
import { dataTypeOptions } from '../../util';

const SystemParameters = () => {
  const [ showModal, setShowModal ] = useState(false);
  const [ selectedParameter, setSelectedParameter  ] = useState(null);
  const [ listParams, setListParams ] = useState([]);
  const [ institutions, setInstitutions ] = useState([]);
  const [ processing, setProcessing ] = useState([]);
  const [ isMapping, setIsMapping ] = useState(false);
  const [ mapModal, setMapModal ] = useState(false);
  // const [  ]
  const { enqueueSnackbar } = useSnackbar();

  const defaultParameter = {
    description: 0,
    max_No_Domains: 0,
    max_No_Users: 0,
    max_No_Roles: 0,
    max_No_DataSets: 0,
    max_No_Views: 0,
    max_No_ResourceGrps: 0,
    max_No_Admin: 0,
    twoFactor: false,
    affectedInstitutions: [],
  };

  const columns = [
    { 
      field: 'sn', headerName: 'S/N', flex: 0.1, sortable: false,
      renderCell: (params) => (
          <p
              style={{ margin: 'auto' }}
          >
              {params?.row?.sn}
          </p>
      )
    },
    {
      field: 'actions', headerName: 'Actions', flex: 0.1, sortable: false,
      renderCell: (params) => (
          <div className='action-icons' style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', width: '100%', padding: '0 0.5rem' }}>
              <IconButton
                  size='small'
                  color="primary"
                  variant="outlined" title='Edit Parameter' className='p-0 m-0'
                  onClick={() => {
                    setSelectedParameter(params?.row || defaultParameter);
                    setShowModal(true)
                  }}
              >
                  <Edit />
              </IconButton>

              <IconButton
                size='small'
                color="primary"
                variant="outlined" title='Set Affected Institutions' className='p-0 m-0'
                onClick={() => {
                    setSelectedParameter(params?.row);
                    setMapModal(true);
                }}
              >
                  <Diversity2Outlined />
              </IconButton>
          </div>
      )
    },
    { field: 'description', headerName: 'Description', flex: 1 },
  ];

  const init = async () => {
    try {
      const res = await getList("institutions");
      const resp = await getList("sys_params");

      console.log("System Parameters", resp)

      if(resp?.responseCode === "00") {
        setListParams(resp?.listing || [])
        setInstitutions(res?.listing || [])
    } else {
        enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
    }

    }
    catch(err) {
      enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
    }
    finally{
      setProcessing(false);
    }
  }; 

  const handleChange = (event, value) => {
    let newAudience = selectedParameter?.affectedInstitutions ? [ ...selectedParameter?.affectedInstitutions ] : [];
    if(value) {
        // if(event.target.name == "001") {
        //     newAudience = [ ...institutions?.map(({ id }) => ({ id }) ) ]
            
        // } else {
        //     newAudience.push(institutions?.find(({ id }) => String(id) == String(event.target.name)));
        // }
        newAudience.push({ id: event.target.name });
    } else {
        // if(event.target.name == "001") {
        //     newAudience = []
        // } else {
        //     newAudience = newAudience.filter(({ id }) => (id != event.target.name) && (id != "001"))
        // }
        newAudience = newAudience.filter(({ id }) => (id != event.target.name) && (id != "001"));
    }
    setSelectedParameter({ ...selectedParameter, affectedInstitutions: newAudience })
  }

  const submitFormFunction = async ( values, { resetForm } ) => {

    try {
      const resp = await AddorUpdateRecord("sysparams", selectedParameter?.id ? "update" : 'add', values);
      if(resp?.responseCode === "00") {
        init();
        setSelectedParameter({});
        setShowModal(false);
        enqueueSnackbar('Action performed successfully')
      }
      else {
        enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' });
      }
    }
    catch(err){
      enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
    }
  };

  const handleMapping = async () => {

    try {
      setIsMapping(true)
      const resp = await AddorUpdateRecord("sysparams", "update", selectedParameter);
      if(resp?.responseCode === "00"){
        init();
        setIsMapping(false);
        setSelectedParameter({});
        setMapModal(false);
        enqueueSnackbar('Mapping Successful');
      }
      else {
        enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' });
      }
    }
    catch(err){
      enqueueSnackbar(err?.message || 'An error occurred', { variant: 'error' })
    }
    finally {
      setIsMapping(false);
    }
  };

  const isChecked = (id) => {
    return (selectedParameter?.affectedInstitutions?.map(x => String(x?.id)).indexOf(String(id)) >= 0) ? true : false;
  }

  useEffect(() => {
    init();
  }, [])

  return (
    <PageContainer pageTitle='System Parameters' processing={processing}>
      <section className="inner-banner parallax-section">
          <div className='overlay'>
              <div className="container">
                  <div className="row">
                      <div className="col-md-12 col-sm-12">
                          <h3 className="wow bounceIn" data-wow-delay="0.9s">System Parameters</h3>
                          {/* <h1 className="wow fadeInUp text-uppercase conference mb-05 mt-05" data-wow-delay="1.6s">Resources</h1> */}
                      </div>
                  </div>
              </div>
          </div>
      </section>
      <div className="services-area section-padding pt-3">
          <div className="container">
              <div className="row">
                  <div className='col-12 text-align-right'>
                      <Button variant="contained" onClick={() => { setSelectedParameter(defaultParameter); setShowModal(true) }}>Create System Parameter</Button>
                  </div>
                  <div className='col-12 mt-4'>
                      <div style={{ height: 600, width: '100%', textAlign: 'center' }}>
                          <CustomDataGrid 
                            columns={columns}
                            rows={listParams}
                          />
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <Dialog open={showModal} maxWidth="md">
        <Formik
          enableReinitialize
          initialValues={selectedParameter}
          onSubmit={submitFormFunction}
        >
          {({ isSubmitting, values, setFieldValue }) => (
            <Form>
              <DialogContent className='pl-4 pr-4'>
                <h3 className='text-bold mt-05' >{selectedParameter?.id ? 'Update' : 'Create'} System Parameter</h3>
                <Divider className="mt-05 mb-2" />
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <TextInput id="description" multiline minRows={2} required label="Description of Parameter" />
                    </Grid>
                    <Grid item xs={4}>
                      <TextInput type="number" id="max_No_Domains" required label="Max Number of Domains" />
                    </Grid>
                    <Grid item xs={4}>
                      <TextInput id="max_No_Users" type="number" required label="Max Number of Users" />
                    </Grid>
                    <Grid item xs={4}>
                      <TextInput id="max_No_Roles" type="number"  required label="Max Number of Roles" />
                    </Grid>
                    <Grid item xs={4}>
                      <TextInput id="max_No_DataSets" type="number" required label="Max Number of DataSets" />
                    </Grid>
                    <Grid item xs={4}>
                      <TextInput id="max_No_Views" type="number" required label="Max Number of Views" />
                    </Grid>
                    <Grid item xs={4}>
                      <TextInput id="max_No_ResourceGrps" type="number" required label="Max Number of Resource Groups" />
                    </Grid>
                    <Grid item xs={4}>
                      <TextInput id="max_No_Admin" type="number" required label="Max Number of Administrators" />
                    </Grid>
                    <Grid item xs={4}>
                      <TextInput id="max_No_Resources" type="number" required label="Max Number of Resources" />
                    </Grid>
                    <Grid item xs={12}>
                      <FormControlLabel
                          control={
                              <Checkbox checked={values.twoFactor} />
                          }
                          label={<b className='f-15'>Enable 2 factor Authentication</b>}
                          name={"twoFactor"}
                          onChange={() => setFieldValue('twoFactor', !values.twoFactor)}
                      />
                  </Grid>
                </Grid>
                
            </DialogContent>
            <DialogActions className='pr-3 pb-3'>
                <Button disabled={isSubmitting} onClick={() => { if(!isSubmitting) { setShowModal(false); setSelectedParameter({}) }}} color="secondary" variant="contained" >Cancel</Button>
                <Button type='submit' variant="contained" disabled={isSubmitting} >
                    {
                        isSubmitting ?
                        <CircularProgress size={15} color="inherit" />
                        :
                        selectedParameter?.id ? 'Update System Parameters' : 'Add System Parameters'
                    }
                </Button>
            </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>

      <Dialog open={mapModal} maxWidth='lg'>
        <DialogTitle className='no-margin m-0 pt-2' style={{ textTransform: 'initial' }}>
            <h4 className='m-0'>Select Affected Institutions</h4>
        </DialogTitle>
        <DialogContent style={{ height: '500px', width: '600px', padding: '0 2rem' }}>
            <FormControl component="fieldset" variant="standard">
                <FormGroup>
                    {
                        institutions.map((institution, key) => (
                            <FormControlLabel
                                control={
                                    <Checkbox checked={isChecked(institution.id)} onChange={handleChange} name={institution.id} />
                                }
                                label={institution.institutionName} key={key}
                            />
                        ))
                    }
                </FormGroup>
            </FormControl>
        </DialogContent>
        <DialogActions style={{ padding: '1rem' }}>
            <Button onClick={() => { setMapModal(false); setSelectedParameter({}) }} color='secondary' variant='contained'>Cancel</Button>

            <Button onClick={handleMapping} color='primary' variant='contained'>
                { isMapping ? <CircularProgress size={15} color='inherit' /> : 'Save Mapping' }
            </Button>
        </DialogActions>
    </Dialog>
    </PageContainer>
  ) 
};

export default SystemParameters;